import { BrowserRouter, Route, Routes } from "react-router-dom";
import OverView from "../pages/OverView";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<OverView />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;